import {isFeatureEnabled} from 'feature-flags';

import {useState} from 'react';

import {isNilOrEmpty} from 'ramda-adjunct';

import {useGetDocument360RedirectUrlQuery} from '@dms/api/security';
import {browserStorageKey} from '@dms/config';
import {featureFlags} from '@dms/feature-flags';
import i18n from '@dms/i18n';

import {isRunningInCypress, useOnMount} from 'shared/web';

export const usePromoFeature = () => {
  const [isOpen, setIsOpen] = useState(false);
  const currentId = i18n.t('ad.feature.id');

  const moreInfoUrl = i18n.t('ad.feature.moreInfoUrl');

  const {data: moreInfoRedirectUrl} = useGetDocument360RedirectUrlQuery(
    {redirectTo: moreInfoUrl},
    {skip: isNilOrEmpty(moreInfoUrl) || !isFeatureEnabled(featureFlags.CORE_NEWS_POPUP)}
  );

  useOnMount(() => {
    const lastPromoFeatureSeen = localStorage.getItem(browserStorageKey.LAST_PROMO_FEATURE_SEEN);
    if (lastPromoFeatureSeen !== currentId && !isRunningInCypress()) {
      setIsOpen(true);
    }
  });

  const handleClose = () => {
    localStorage.setItem(browserStorageKey.LAST_PROMO_FEATURE_SEEN, currentId);
    setIsOpen(false);
  };

  return {isOpen, moreInfoRedirectUrl: moreInfoRedirectUrl?.redirectUrl, handleClose};
};
